import get from "lodash.get";
import { renderHealingIndexMean } from "src/utils/woundRiskUtils";

export function woundRiskFormatter(cell, row) {
  let healingIndexMean = get(row, "attributes.healingIndexMean", "");
  const healingIndexCategoryList = true;
  return renderHealingIndexMean(healingIndexMean, healingIndexCategoryList);
}
